import React, { useCallback, useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';

// Utils
import { useIsMobileWidth } from 'utils/hooks/useIsMobile';

// Components
import { Modal } from '@beef/ui-kit';
import { MODAL_NAMES } from 'constants/modal';
import { openPopup } from 'actions';
import { ContentSection, SuccessSection } from './components';
import { setSaveRegularDetalizationReportInitialControlsData } from '../../store/regularDetalizationReport/actions';
import { setDetalizationConfirmData } from '../../store/personalDataStore/actions';

export const RegularDetalizationReportModal = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  const isMobile = useIsMobileWidth();

  const {
    modalName,
    isUpdatingSuccess,
  } = useSelector(({ application, detalizationNew }) => ({
    modalName: application.popup,
    isUpdatingSuccess: detalizationNew.regularDetalizationReport.isUpdatingSuccess,
    subscriptionStatus: detalizationNew.regularDetalizationReport.subscriptionStatus,
  }), shallowEqual);

  useEffect(() => {
    setIsOpen(modalName === MODAL_NAMES.REGULAR_DETALIZATION_REPORT);
  }, [modalName]);

  const isLowerSizePopup = isMobile || (isUpdatingSuccess);

  const onCloseModal = useCallback(() => {
    dispatch(openPopup(null));
    dispatch(setSaveRegularDetalizationReportInitialControlsData());
    dispatch(setDetalizationConfirmData());
  }, [dispatch]);

  return (
    <Modal
      isOpen={isOpen}
      size={isLowerSizePopup ? 'xs' : 'm'}
      isCentered={isLowerSizePopup}
      onClose={onCloseModal}
    >
      {isUpdatingSuccess
        ? (
          <SuccessSection onClick={onCloseModal} />
        )
        : <ContentSection isMobile={isMobile} />}
    </Modal>
  );
};
